import { render, staticRenderFns } from "./collaboration.svg.vue?vue&type=template&id=0ec7392a"
import script from "./collaboration.svg.vue?vue&type=script&lang=ts"
export * from "./collaboration.svg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ec7392a')) {
      api.createRecord('0ec7392a', component.options)
    } else {
      api.reload('0ec7392a', component.options)
    }
    module.hot.accept("./collaboration.svg.vue?vue&type=template&id=0ec7392a", function () {
      api.rerender('0ec7392a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/assets/landing/LandingContentBox/collaboration.svg.vue"
export default component.exports